// 由于在request.js里面暴露的方法是默认暴露，仅有一个方法，没有其他的方法干扰
// 这里引入时，import 后面跟着的名字，就可以随便写，我在request.js里暴露时，
// 明明起的名字叫service, 在这里引入的时候，我就叫它request，request是新起的名字
import request from "@/utils/request"

// 参数data代表在.vue文件里调用这个方法时传进去的值，没有就是undefined,
// 你给服务器发网络请求，多发一些参数给后端也没关系。所以，在不传值的应用场景，
// 就是给它发个undefined，也没啥大事
// 验证码接口
export function captcha(data) {
    return request({
      url: "/client/captcha",
      method: "post",
      data,
    });
}

// 注册接口
export function register(data) {
    return request({
      url: "/client/register",
      method: "post",
      data,
    });
}

// 登录接口
export function login(data) {
  return request({
    url: "/client/login",
    method: "post",
    data,
  });
}

// 退出登录接口
export function logout(data) {
  return request({
    url: "/client/logout",
    method: "post",
    data,
  });
}
